// Integration point for search quality assessment.
// Replace the console.log bodies with calls to your analytics / logging service
// without changing the call sites.

/**
 * Report a comparison between the displayed provider's results and a shadow
 * provider's results for the same query. Called by the SearchOrchestrator
 * whenever a shadow provider returns results.
 *
 * @param {Object} report
 * @param {string} report.query                 - The search query
 * @param {string} report.displayedProvider     - ID of the provider whose results are shown
 * @param {Object} report.displayedResults      - Full results shape from the displayed provider
 * @param {string} report.shadowProvider        - ID of the shadow provider
 * @param {Object} report.shadowResults         - Full results shape from the shadow provider
 */
export function reportSearchComparison({
  query,
  displayedProvider,
  displayedResults,
  shadowProvider,
  shadowResults,
}) {
  // eslint-disable-next-line no-console
  console.log('[searchReporter] comparison', {
    query,
    displayedProvider,
    displayedResults,
    shadowProvider,
    shadowResults,
  })
}

/**
 * Report a single provider's results (e.g. for logging purposes without a
 * shadow comparison). Also used by additive providers to record their output.
 *
 * @param {Object} report
 * @param {string} report.provider  - Provider ID
 * @param {string} report.query     - The search query
 * @param {Object} report.results   - Full results shape
 */
export function reportSearchResults({ provider, query, results }) {
  // eslint-disable-next-line no-console
  console.log('[searchReporter] results', { provider, query, results })
}
